import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY } from "../lib/data";

const cols = [
  { heading: "Company", links: [["About", "/about"], ["Projects", "/projects"], ["Contact", "/contact"]] },
  { heading: "Services", links: [["Building Envelope Consulting", "/services"], ["New Construction", "/services"], ["Energy Modeling", "/services"], ["Air Leakage Testing", "/services"], ["Roofing & Waterproofing", "/services"]] },
  { heading: "Projects", links: [["Current Projects", "/projects"], ["Completed Projects", "/projects"]] },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white relative overflow-hidden" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Logo light />
            <div className="flex gap-3 mt-6">
              <a href={COMPANY.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin"
                 className="w-10 h-10 bg-white text-navy flex items-center justify-center hover:bg-brand hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email"
                 className="w-10 h-10 bg-white text-navy flex items-center justify-center hover:bg-brand hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.heading}>
              <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-white/50 mb-4">{col.heading}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to], i) => (
                  <li key={i}>
                    <Link to={to} className="text-sm text-white/80 hover:text-white transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-white/50 mb-4">Contact</h4>
            <address className="not-italic text-sm text-white/80 space-y-2 leading-relaxed">
              <p>{COMPANY.address.join(", ")}</p>
              <p>{COMPANY.phone}</p>
              <p>{COMPANY.email}</p>
            </address>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row justify-between items-center gap-4 pt-6 border-t border-white/10 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {COMPANY.name} All rights reserved.</p>
          <div className="flex gap-6">
            <span className="hover:text-white transition-colors cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white transition-colors cursor-pointer">Terms of Use</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
